function Luminode() {
  return (
    <svg
      width={36}
      height={30}
      viewBox="0 0 36 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.299316 7.76001L7.51874 10.8995L18.1157 15.5082V21.7891L0.299316 14.0409"
        fill="#1C6BD3"
      />
      <path
        d="M0.299316 14.0291L7.51874 10.8896L18.1157 6.2809V0L0.299316 7.7482"
        fill="#1F79F0"
      />
      <path
        d="M28.7127 18.6593L18.1157 23.268V29.5489L35.9321 21.7987V15.5198L28.7127 18.6593Z"
        fill="#1C6BD3"
      />
      <path
        d="M28.7127 18.6477L18.1157 14.0409V7.76001L35.9321 15.5082V21.7891L28.7127 18.6477Z"
        fill="#1F79F0"
      />
    </svg>
  );
}

export default Luminode;